import { createSlice } from '@reduxjs/toolkit';
import { defaultValues } from '../data/DefaultTranslationValues';
import { BUSINESS_UNITS_RENAME_GATE } from '../constants/gates';
export const initialState = [];
export const BusinessUnitsSlice = createSlice({
  name: 'businessUnits',
  initialState,
  reducers: {}
});
export const allBusinessUnit = (portalId, allBusinessUnitsText) => {
  return {
    hubId: portalId,
    name: allBusinessUnitsText || defaultValues['nav.tools.allBusinessUnits'],
    allUsersHaveAccess: true,
    id: 'ALL'
  };
};
export const getBusinessUnits = state => {
  const isUngatedForBusinessUnitsRebrand = state.portal.gates.includes(BUSINESS_UNITS_RENAME_GATE);
  return [allBusinessUnit(state.portal.portalId, isUngatedForBusinessUnitsRebrand ? state.translations['nav.tools.allBrands'] : state.translations['nav.tools.allBusinessUnits']), ...state.businessUnits];
};
export default BusinessUnitsSlice.reducer;